export default {
  audioFile: {
    fileSize: 'ファイルサイズ',
    musicDuration: '音楽の長さ',
    cutting: 'クリップ',
    duration: '取得中...',
  },
  audioLoop: {
    title: '再生',
    playSetting: '再生設定',
    autoPlay: '起動時自動再生',
    cycles: '再生回数',
    formItemList: {
      loopNumber: '回',
      loop: 'ループ',
    },
  },
  audioSetting: {
    soundEffect: '効果音',
    volume: '音量',
  },
  audioEditor: {
    argumentsAreEmpty: 'URLは必須のパラメータです',
  },
  dialog: {
    title: 'オーディオクリップ',
    soundTitle: 'サウンドエフェクトのトリミング',
  },
}
